import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';

import DateString from '../common/DateString';
import ExpansionButton from '../common/ExpansionButton';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    className: PropTypes.string,
    folder: PropTypes.object.isRequired,
    onToggleExpansion: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    depth: PropTypes.number,
    goToFolderView: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
    expanded: false,
    depth: 0,
};

function FolderListItem(props) {
    if (!props.folder) {
        return null;
    }

    function _goToFolderView(e) {
        e.stopPropagation();
        props.goToFolderView(props.folder.id);
    }

    return (
        <li className={`${props.className} listing--noBg projectListing`}>
            <Row className="projectListing__wrapper">
                <div className={`col-3 col-sm-2 col-md-1 projectListing__col--control projectListing__col--depth-${props.depth} nowrap`}>
                    <div className="listDepthWrapper">
                        <ExpansionButton
                            className="width-100p height-100p text-left padding-l-sm"
                            expanded={props.expanded}
                            onClick={props.onToggleExpansion}
                            expandedIcon="fa-caret-down"
                            collapsedIcon="fa-caret-right"
                        >
                            <AccessibleIcon className="fa fa-folder fa-lg fa-fw" label="Folder" />
                        </ExpansionButton>
                    </div>
                </div>
                <button
                    className="bare-text-button no-button-style col-7 col-sm-7 col-md-5 col-lg-3 projectListing__col--clipText link-plain link-body-color"
                    onClick={_goToFolderView}
                >
                    <div title={props.folder.name}>{props.folder.name}</div>
                </button>
                <button
                    className="bare-text-button no-button-style d-none d-md-flex col-md-2 col-lg-2 projectListing__col link-plain link-body-color nowrap text-md"
                    onClick={_goToFolderView}
                >
                    <DateString shortMonth date={props.folder.created_at} />
                </button>
                <button
                    className="bare-text-button no-button-style col-2 col-sm-3 col-md-4 col-lg-6"
                    onClick={_goToFolderView}
                >
                </button>
            </Row>
        </li>
    );
}

FolderListItem.propTypes = propTypes;
FolderListItem.defaultProps = defaultProps;

export default FolderListItem;
